import { PhysicalSensorModelSdResponse } from '@kcftech/prometheus-client';
import { skipToken, UseQueryOptions, useQuery } from '@tanstack/react-query';
import { sdClient } from 'contexts/SDKClientContext';
import { queryClient } from 'utils/query';
import { Filter } from 'utils/query_v3';

const queryKey = 'third-party-sensors-details';

export function useThirdPartySensorDetails(
    id: string | undefined,
    options?: UseQueryOptions<PhysicalSensorModelSdResponse | undefined>,
) {
    return useQuery({
        queryKey: [queryKey, id],

        queryFn:
            id !== undefined
                ? () =>
                      sdClient
                          .sdGetPhysicalSensorModels({ filter: Filter.eq('Id', id) })
                          .then((r) => r.Result[0])
                : skipToken,

        ...options,
    });
}

export function invalidateThirdPartySensorDetails(id: string) {
    queryClient.invalidateQueries({
        queryKey: [queryKey, id],
    });
}
